import { Stack } from "@mui/material";
import VoicesTable from "../tables/VoicesTable";
import VoicesFilter from "../filters/VoicesFilter";

function Voices({legalEntity, dealer, type}: {legalEntity: string, dealer: string, type: string}) {

    return (
        <Stack direction={'column'} spacing={2} margin={"16px"}>
            <VoicesFilter legalEntity={legalEntity} dealer={dealer}/>
            <VoicesTable legalEntity={legalEntity} dealer={dealer} type={type}/>
        </Stack>
    )
}

export default Voices;